module.exports = __webpack_public_path__ + "img/sonic.0d64664b.jpg";